import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcBack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4L7 12L16 20",
			stroke: "currentColor",
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4L7 12L16 20",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4L7 12L16 20",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4L7 12L16 20",
			stroke: "currentColor",
			strokeOpacity: .2,
			strokeWidth: 1.8,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIcBack;
